import React, { Component } from "react";
import { Form} from 'semantic-ui-react';
import  Logo  from "./logo";
import api from "../core/api";
import CustomField from "./CustomField";
//import { login } from "../core/auth";
//import {getToken} from "../core/auth";
import { logout } from "../core/auth";
import trocaSenhaImg from "../img/troca-senha.png";
import { isUndefined } from "util";
import formatError from "../js/formatError"

class Validacao extends Component {

  constructor(props){
    super(props);
    // debugger;
    this.state = {
      camposValidacao:[],
      nomeMae: "",
      cpf: "",
      error: isUndefined(this.props.history.location.state) || isUndefined(this.props.history.location.state.passo)?"Você deve passar por todo o fluxo da troca de senha.":"",
      passo: isUndefined(this.props.history.location.state)?false:!isUndefined(this.props.history.location.state.passo) ,
      resultsMessage: "",
      adm:null,
      valoresValidacao:new Map(),
    };
   // console.log(this.state);
    this._buscarCampos();
  }

  _buscarCampos() {
    //debugger;
    api.post("/buscarCampos",{}) 
      .then(res => {
          //debugger           
          this.setState({
            camposValidacao: res.data, 
            resultsMessage: res.data.length === 0 ? 'Nenhum resultado encontrado.' : null 
          });
        }
      )
      .catch(err => {
//        debugger;
        formatError(err.response, this);
      }
    );
  }
  
  handleCancelar = async e => {
    if(window.confirm("Atenção: Tem certeza que deseja cancelar a troca de sua senha?")) {
      logout();
      this.props.history.push("/");
    }
  }

  handleContinuar = async e => {
    const mapa = [];
    //debugger;
    for(var i = 0, keys = this.state.valoresValidacao.keys(), k= keys.next(); i < this.state.valoresValidacao.size; i++, k = keys.next()){
      mapa.push({[k.value]:this.state.valoresValidacao.get(k.value)});

    }

    // Validar dados do usuário logado
    try {
      await api.post("/valid", {dados:JSON.stringify(mapa)})
        .then(res => {
            this.setState({
              adm: res.data
            });
          }
        );

     // console.log(this.state.adm);
      if(this.state.adm){
        this.props.history.push("/troca",{passo:2});
      } else {
        this.props.history.push("/termo",{passo:2});
      }
    } catch(err) {
      //console.log(err)
      //debugger;
      formatError(err.response, this);
    }
  };
  
  _setValorCampo(nm, vlr){
    //console.log("nome:["+nm+"] valor:["+ vlr +"]");
    this.state.valoresValidacao.set(nm, vlr);
    //console.log(this.state.valoresValidacao);
  }

  render() {
    //console.log(this.state);
    if(!this.state.passo) {
      this.props.history.push("/");
    }
    return (
      <div className="container">
        <div className="row">
          <div className="col-sm-9 col-md-7 col-lg-5 mx-auto">
            <h5 className="card-title text-center margin-top">
              <img src={trocaSenhaImg} className="img-responsive troca-senha" alt="Confirmação de Dados" />
            </h5>
            <p>Confirmação de Dados</p>
            <Form onSubmit={this.handleContinuar} autoComplete="off">
                {this.state.error && <div className="msgError center">{this.state.error}</div>}
                {this.state.resultsMessage && <div className="msgWarning center">{this.state.resultsMessage}</div>}
              {this.state.camposValidacao && this.state.camposValidacao.map((v, i) =>
                <div key={i}>
                  <CustomField 
                    autoFocus={i===0}
                    type={v.tipo}
                    id={v.nome}
                    title={v.descricao}
                    value={v.valor}
                    help={v.help}
                    maxLength={v.tamanho}
                    className="form-control margin-button-input margin-top-input bkg-verde" 
                    placeholder={v.help} 
                    options={v.opcoes}
                    action={(nome, valor)=> this._setValorCampo(nome, valor)}
                    selected={this.state[v.nome]}
                      />
                </div>
              )}                                    
              <button id="btnContinuar" className="btn btn-primary btn-block margin-top-input text-uppercase" type="submit">ACESSAR</button>
              <button id="btnCancelar" className="btn btn-secondary btn-block text-uppercase" type="button" onClick={this.handleCancelar}>CANCELAR</button>
              <Logo />
            </Form>
          </div>
        </div>
      </div>
    );
  }
}

export default Validacao;
